export default __webpack_public_path__ + "static/media/element_spec_59.7b1d4756.jpg";